import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class home_template extends vnTemplate{

    protected getTemplateHtml(): string{
        return ``;

    }

    protected getTemplateName(): string{
        return "home-template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected buildViewModel(): any{

        let huit_neuf_this = this;
        return  {  };
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/home_template.ts